import { CaseStudy } from "@/components/patientCaseStudy";
import { ICaseStudyData } from "@/interfaces";
import cmsService from "@/libs/services/cmsService";
import { GetServerSideProps } from "next";
type props = {
  caseStudyData: ICaseStudyData
}
const doctorsProfile = ({ caseStudyData }: props) => {
  return <CaseStudy caseStudyData={caseStudyData}/>
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const casestudySlug: any = context.params?.casestudy;
  const casestudyDetails = await cmsService.getCaseStudyDetailsBySlug(casestudySlug)
  if (!casestudyDetails)
    return {
      notFound: true
    }
  return {
    props: {
      caseStudyData: {
        caseStudyDetails: casestudyDetails[0]
      }
    },
  };
};

export default doctorsProfile;
